import { log } from '../../shared/utils/log';

const flexDirections = ['row', 'column', 'row-reverse', 'column-reverse'];

export function flex(direction) {
    const css = 'display: flex;';
    if (!direction) return css;
    const flexDirection = flexDirections.find(element => {
        return element === direction;
    });
    if (!flexDirection) {
        log.warning(`${direction}is not a valid flex direction`);
        return css;
    }
    return `${css} flex-direction: ${direction}`;
}
